import { FETCH_CATEGORY_ARTICLE_LIST } from '../types';

export const categoryArticleDataReducer = (
  state = { isLoading: true, data: []},
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_CATEGORY_ARTICLE_LIST:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};